import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import ImageSelector from '@di-shared/features/common/ImageSelector';

export function BatteryStatusGood() {
  const {t} = useInferableTranslation();

  return (
    <>
      <div className="section_heading type_main">
        <h2
          className="section_heading_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {t('T30097')}
        </h2>
        <p className="section_heading_desc">{t('T30098')}</p>
      </div>

      <div className="section_visual visual_battery">
        <ImageSelector
          className="section_visual_img"
          alt="section_visual_img"
          kiaLightSrc={() => import('@di-shared/assets/img/visual/battery_good_light.png')}
          kiaDarkSrc={() => import('@di-shared/assets/img/visual/battery_good.png')}
          hyundaiLightSrc={() => import('@di-shared/assets/img/visual/hyundai/battery_good_light.png')}
          hyundaiDarkSrc={() => import('@di-shared/assets/img/visual/hyundai/battery_good.png')}
          genesisLightSrc={() => import('@di-shared/assets/img/visual/genesis/battery_good_light.png')}
          genesisDarkSrc={() => import('@di-shared/assets/img/visual/genesis/battery_good.png')}
        />
      </div>
    </>
  );
}

export function BatteryStatusWarning() {
  const {t} = useInferableTranslation();

  return (
    <>
      <div className="section_heading type_main">
        <h2
          className="section_heading_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {t('T30099')}
        </h2>
        <p className="section_heading_desc">{t('T30100')}</p>
      </div>

      <div className="section_visual visual_battery">
        <ImageSelector
          className="section_visual_img"
          alt="section_visual_img"
          kiaLightSrc={() => import('@di-shared/assets/img/visual/battery_warning_light.png')}
          kiaDarkSrc={() => import('@di-shared/assets/img/visual/battery_warning.png')}
          hyundaiLightSrc={() => import('@di-shared/assets/img/visual/battery_warning_light.png')}
          hyundaiDarkSrc={() => import('@di-shared/assets/img/visual/battery_warning.png')}
          genesisLightSrc={() => import('@di-shared/assets/img/visual/battery_warning_light.png')}
          genesisDarkSrc={() => import('@di-shared/assets/img/visual/battery_warning.png')}
        />
      </div>
    </>
  );
}
